export const getFolderAccess = folder =>
    folder?.accessCapabilities || {
        canCreateFolders: true,
        canAdd: true,
        canEdit: true,
        canManage: true,
        canGenerate: true,
        canReadThreads: true
    };

export const resolveFolderCapabilities = (folder, userId, canContribute, canCreateSubfolders, canAdd, { isVirtualView = false } = {}) => {
    // Stack/Type views filter the user's messages; they have no folder owner.
    // Ignore any stale capabilities previously assigned to that virtual shell.
    if (isVirtualView && !folder?.publishedToken) return getFolderAccess();
    const owner = Boolean(userId && String(folder?.owner) === String(userId));
    return {
        canCreateFolders: owner || canCreateSubfolders === true,
        canAdd: owner || canContribute === true || canAdd === true,
        canEdit: owner || canContribute === true,
        canManage: owner,
        canGenerate: owner,
        canReadThreads: true
    };
};

export const buildPublishedFolderReference = (content, token) => {
    if (!content?.folder) return null;
    const id = `public:${token}`;
    const folder = {
        ...content.folder,
        id,
        owner: 'public',
        publishedToken: token,
        accessCapabilities: { canCreateFolders: false, canEdit: false, canManage: false, canGenerate: false, canReadThreads: false }
    };
    return {
        folder,
        parent: null,
        path: [],
        folders: [],
        viewerCanContribute: false,
        messages: {
            ...content.messages,
            messages: (content.messages?.messages || []).map(message => ({
                ...message,
                id: `${id}:${message.id}`,
                sourceMessageId: message.id,
                folder
            }))
        }
    };
};
